// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2gPBW","container":"styles_container__3ixiW","title":"styles_title__3sNJ-","wrapper":"styles_wrapper__1w7Ul","answer":"styles_answer__1ZRJV"};